import { SettingsIntegrationService } from '@app/modules/settings/services';
import { ApplicantProfileService } from '@applicant-tracker/services/applicant-profile.service';
import { HiringTeamAssignmentService } from '@applicant-tracker/services/hiring-team-assignment.service';
import { IndeedValidationService } from '@applicant-tracker/services/indeed-validation.service';
import { SubscriptionService } from '@applicant-tracker/services/subscription.service';
import { ApplicantIndividualMessageService } from './applicant-individual-message.service';
import { ApplicantMessageService } from './applicant-message.service';
import { ApplicantOptionalFieldService } from './applicant-optional-fields.service';
import { ApplicantService } from './applicant.service';
import { FunnelTemplateService } from './funnel-template.service';
import { HiringPermissionsService } from './hiring-permissions.service';
import { InterviewService } from './interview.service';
import { JobBoardService } from './job-board.service';
import { JobPostingQuestionsService } from './job-posting-questions.service';
import { ManageInterviewService } from './manage-interview.service';
import { ApplicantDocumentsIndexTable } from './tables/applicant-documents-table/applicant-documents-index.table';
import { ApplicantInterviewsTable } from './tables/applicant-interviews-table/applicant-interviews.table';
import { EmailHistoryIndexTable } from './tables/email-history-table/email-history-index.table';
import { InterviewIndexTable } from './tables/interview-index-table/interview-index.table';
import { FunnelTemplatesIndexTable } from './tables/template-table/funnel-template-index.table';

const Services = [
    ApplicantService,
    HiringPermissionsService,
    FunnelTemplateService,
    FunnelTemplatesIndexTable,
    EmailHistoryIndexTable,
    ApplicantDocumentsIndexTable,
    SettingsIntegrationService,
    ApplicantMessageService,
    ApplicantIndividualMessageService,
    IndeedValidationService,
    ApplicantProfileService,
    ApplicantInterviewsTable,
    InterviewService,
    JobBoardService,
    InterviewIndexTable,
    ManageInterviewService,
    SubscriptionService,
    HiringTeamAssignmentService,
    JobPostingQuestionsService,
    ApplicantOptionalFieldService,
];

export {
    ApplicantDocumentsIndexTable,
    ApplicantIndividualMessageService,
    ApplicantMessageService,
    ApplicantOptionalFieldService,
    ApplicantProfileService,
    ApplicantService,
    EmailHistoryIndexTable,
    FunnelTemplateService,
    FunnelTemplatesIndexTable,
    HiringPermissionsService,
    HiringTeamAssignmentService,
    IndeedValidationService,
    InterviewIndexTable,
    InterviewService,
    JobBoardService,
    JobPostingQuestionsService,
    ManageInterviewService,
    Services,
    SettingsIntegrationService,
    SubscriptionService,
};
